import React from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { theme } from '../constants';

type Props = {
  title: string;
  viewAllVisible?: boolean;
  viewAllOnClick?: () => void;
  containerStyle?: any;
  icon?: React.ReactNode;
};

export const BlockHeading: React.FC<Props> = ({
  title,
  viewAllOnClick,
  containerStyle,
  icon,
  viewAllVisible = true,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ...theme.flex.rowCenterSpaceBetween,
        ...containerStyle,
      }}
    >

      <h3
        style={{
          display: 'ruby',
          margin: 0,
          fontSize: 15,
          ...theme.fonts.Mulish_700Bold,
          color: theme.colors.mainColor,
          lineHeight: 1.2,
        }}
      >
          {icon && (
          <span style={{ color: theme.colors.mainColor, fontSize: 20, paddingLeft:5,}}>
            {icon}
          </span>
        )}
        {title}
      </h3>
      {viewAllVisible && (
        <button
          onClick={viewAllOnClick}
          style={{ lineHeight: 0, marginRight: '10px' }}
        >
          {/* <svg.ViewAllSvg /> */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              color: '#193364',
            }}
          >
            <span
              style={{
                fontSize: '14px',
                marginRight: '2px',
                color: theme.colors.mainColor,
              }}
            >
              مشاهده همه
            </span>
            <IoIosArrowDown
              size={14}
              style={{ rotate: '90deg', margin: '0px',  color: theme.colors.mainColor,}}
            />
          </div>
        </button>
      )}
    </div>
  );
};
